import { render, staticRenderFns } from "./RouterLinkExt.vue?vue&type=template&id=51a4f75d&"
import script from "./RouterLinkExt.vue?vue&type=script&lang=ts&"
export * from "./RouterLinkExt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports